import React, {useState, useEffect, useContext} from "react";
import {Link} from "react-router-dom";
import SideBar from "../components/SideBar";
import Search from "./Search";
import Footer from "../shared/Footer";


export default function Register({handleClick}:any) {

    document.title = 'Get a Handicap - Search Zipcode';


    return (
    <div className="container App_container">


        <div className="col-12 col-sm-10 col-md-10 col-lg-10 mx-auto">
            <Search handleClick={handleClick}/>
        </div>
        
    </div>

    )
}
